// Registre unique des icônes de skill : source de vérité partagée par le type
// `PromptIcon`, le sélecteur d'icône de l'éditeur et tous les composants qui
// affichent un skill. Ajouter une icône ici la rend disponible partout.
import {
  DocumentTextIcon,
  NewspaperIcon,
  MagnifyingGlassIcon,
  ChartBarIcon,
  ClockIcon,
  GlobeAltIcon,
  PhotoIcon,
  FilmIcon,
  LanguageIcon,
  CheckBadgeIcon,
  LightBulbIcon,
  SparklesIcon,
  MapPinIcon,
  CalendarDaysIcon,
  UserGroupIcon,
  BookOpenIcon,
  TableCellsIcon,
  ArrowTrendingUpIcon,
  ScissorsIcon,
  ChatBubbleBottomCenterTextIcon
} from '@heroicons/vue/24/outline'
import type { FunctionalComponent } from 'vue'

export const SKILL_ICONS = {
  'document-text': DocumentTextIcon,
  newspaper: NewspaperIcon,
  'magnifying-glass': MagnifyingGlassIcon,
  'chart-bar': ChartBarIcon,
  clock: ClockIcon,
  'globe-alt': GlobeAltIcon,
  photo: PhotoIcon,
  film: FilmIcon,
  language: LanguageIcon,
  'check-badge': CheckBadgeIcon,
  'light-bulb': LightBulbIcon,
  sparkles: SparklesIcon,
  'map-pin': MapPinIcon,
  'calendar-days': CalendarDaysIcon,
  'user-group': UserGroupIcon,
  'book-open': BookOpenIcon,
  'table-cells': TableCellsIcon,
  'arrow-trending-up': ArrowTrendingUpIcon,
  scissors: ScissorsIcon,
  'chat-bubble-bottom-center-text': ChatBubbleBottomCenterTextIcon
} as const satisfies Record<string, FunctionalComponent>

export type PromptIcon = keyof typeof SKILL_ICONS

export const SKILL_ICON_NAMES = Object.keys(SKILL_ICONS) as PromptIcon[]

export const DEFAULT_SKILL_ICON: PromptIcon = 'document-text'

function isPromptIcon(icon: string): icon is PromptIcon {
  return icon in SKILL_ICONS
}

export function normalizePromptIcon(icon?: string): PromptIcon {
  return icon && isPromptIcon(icon) ? icon : DEFAULT_SKILL_ICON
}
